import * as yup from "yup";

const formSchema = personType => {
  const schema = yup.object({
    name: personType === 0 ? yup.string().required("نام الزامی") : null,
    enName: personType === 0 ? yup.string() : null,
    family:
      personType === 0 ? yup.string().required("نام خانوادگی الزامی") : null,
    enFamily: personType === 0 ? yup.string() : null,
    company: personType === 1 ? yup.string().required("شرکت الزامی") : null,
    enCompany: personType === 1 ? yup.string() : null,
    phone: yup.string().required("موبایل الزامی"),
    tel: yup.string(),
    postCode: yup.string(),
    country: yup.number().required("کشور الزامی").min(1, "کشور الزامی"),
    city: yup.string().required("شهر الزامی"),
    enCity: yup.string(),
    address: yup.string().required("آدرس الزامی"),
    enAddress: yup.string(),
  });

  return schema;
};

export default formSchema;
